import {api,post} from './api.js';

export type WorkoutPushState='checking'|'unsupported'|'unconfigured'|'off'|'on'|'denied';
type PushSettings={configured:boolean;public_key:string|null;subscriptions:number};
let configuredPublicKey:string|null=null;

export function supportsWorkoutPush(){
  return window.isSecureContext&&'serviceWorker'in navigator&&'PushManager'in window&&'Notification'in window;
}

export function urlBase64ToUint8Array(value:string){
  const padding='='.repeat((4-value.length%4)%4),base64=(value+padding).replace(/-/g,'+').replace(/_/g,'/'),raw=globalThis.atob(base64);
  return Uint8Array.from(raw,character=>character.charCodeAt(0));
}

export async function registerFitnessServiceWorker(){
  if(!('serviceWorker'in navigator)||!(window.isSecureContext||location.hostname==='localhost'||location.hostname==='127.0.0.1'))return null;
  try{return await navigator.serviceWorker.register('/sw.js',{scope:'/',updateViaCache:'none'});}catch{return null;}
}

async function registration(){
  if(!await registerFitnessServiceWorker())throw new Error('service_worker_registration_failed');
  return navigator.serviceWorker.ready;
}

export async function getWorkoutPushState():Promise<WorkoutPushState>{
  if(!supportsWorkoutPush())return 'unsupported';
  const settings=await api<PushSettings>('/api/push-settings');
  if(!settings.configured||!settings.public_key){configuredPublicKey=null;return 'unconfigured';}
  configuredPublicKey=settings.public_key;
  const subscription=await (await registration()).pushManager.getSubscription();
  if(subscription)return 'on';
  return Notification.permission==='denied'?'denied':'off';
}

export async function enableWorkoutPush():Promise<WorkoutPushState>{
  if(!supportsWorkoutPush())return 'unsupported';
  const permission=Notification.permission==='granted'?'granted':await Notification.requestPermission();
  if(permission!=='granted')return 'denied';
  const publicKey=configuredPublicKey??(await api<PushSettings>('/api/push-settings')).public_key;
  if(!publicKey)return 'unconfigured';
  const worker=await registration(),existing=await worker.pushManager.getSubscription();
  const subscription=existing??await worker.pushManager.subscribe({userVisibleOnly:true,applicationServerKey:urlBase64ToUint8Array(publicKey)});
  try{await post('/api/push-subscriptions',{subscription:subscription.toJSON(),user_agent:navigator.userAgent});}
  catch(error){if(!existing)await subscription.unsubscribe();throw error;}
  return 'on';
}

export async function disableWorkoutPush():Promise<WorkoutPushState>{
  if(!supportsWorkoutPush())return 'unsupported';
  const worker=await registration(),subscription=await worker.pushManager.getSubscription();
  if(subscription){await post('/api/push-subscriptions/remove',{endpoint:subscription.endpoint});await subscription.unsubscribe();}
  return Notification.permission==='denied'?'denied':'off';
}
